// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getInvoiceState, InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import displayInvoice from "@store/Framework/Store/Store/Pages/ReturnRequest/Handlers/DisplayInvoice";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);

    let invoiceNumber;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ invoiceNumber: string }>(location.search);
        invoiceNumber = parsedQuery.invoiceNumber;
    }

    const isInvoiceNumberStoredInState = state.store.pages.returnRequest.invoiceNumber === invoiceNumber;

    return {
        invoiceNumber,
        invoiceState: getInvoiceState(state, invoiceNumber),
        shouldDisplayInvoice: !isInvoiceNumberStoredInState,
    };
};

const mapDispatchToProps = {
    displayInvoice,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

class ReturnRequestRmaPage extends React.Component<Props> {
    UNSAFE_componentWillMount(): void {
        // The share entity (for orders) functionality can use this page
        // to render HTML for PDF generation, so we need to leave this SSR
        // ability so that functionality works.
        if (this.props.invoiceNumber && this.props.shouldDisplayInvoice) {
            this.props.displayInvoice({
                invoiceNumber: this.props.invoiceNumber,
                additionalExpands: ["shipments", "rmadata"],
            });
        }
    }

    render() {
        return (
            <Page>
                <InvoiceStateContext.Provider value={this.props.invoiceState}>
                    <Zone contentId={this.props.id} zoneName="Content" />
                </InvoiceStateContext.Provider>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ReturnRequestRmaPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;
